import { useCallback, useEffect, useRef, useState } from 'react';

export const REPEAT_INPUT_LOCK_MS = 300;

// Keep rapid taps from counting twice, without using a visual flash as a lock.
// Async repetitions keep the lock until their request has also finished.
export default function useRepeatInputLock() {
  const [locked, setLocked] = useState(false);
  const lockedRef = useRef(false);
  const startedAtRef = useRef(0);
  const timerRef = useRef(null);
  const mountedRef = useRef(false);

  useEffect(() => {
    mountedRef.current = true;
    return () => {
      mountedRef.current = false;
      clearTimeout(timerRef.current);
    };
  }, []);

  const begin = useCallback(() => {
    if (lockedRef.current || !mountedRef.current) return false;
    lockedRef.current = true;
    startedAtRef.current = Date.now();
    setLocked(true);
    return true;
  }, []);

  const finish = useCallback(() => {
    if (!mountedRef.current || !lockedRef.current) return;
    clearTimeout(timerRef.current);
    const release = () => {
      timerRef.current = null;
      lockedRef.current = false;
      if (mountedRef.current) setLocked(false);
    };
    const remaining = Math.max(0, REPEAT_INPUT_LOCK_MS - (Date.now() - startedAtRef.current));
    if (remaining > 0) timerRef.current = setTimeout(release, remaining);
    else release();
  }, []);

  return { locked, begin, finish };
}
